__turbopack_context__.v({
  "caption": "HoWp2W_caption",
  "close": "HoWp2W_close",
  "dialog": "HoWp2W_dialog",
  "next": "HoWp2W_next",
  "pause": "HoWp2W_pause",
  "photo": "HoWp2W_photo",
  "previous": "HoWp2W_previous",
  "section": "HoWp2W_section",
  "studioMarquee": "HoWp2W_studioMarquee",
  "thumbnail": "HoWp2W_thumbnail",
  "track": "HoWp2W_track",
  "viewport": "HoWp2W_viewport",
});
